import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    host: {
        '(document:click)': 'onOutsideClick($event)',
    },
    selector: 'icon-picker',
    templateUrl: 'icon-picker.component.html',
    styles: [`
    
    .icon-picker ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        background-color: white;
        
        height: 200px;
        overflow: auto;
      }
      
      .icon-picker  li {
        float: left;
        color:white;
        display:flex;
        color: white;
        text-align: center;
        padding: 16px;
        text-decoration: none;
      }
      
      
      .icon-picker ul li:hover {
      background-color: #8f8f8f;
      }
    
    `]
})

export class IconPickerComponent implements OnInit, OnChanges {

    @Input() initIconPicker: string;
    @Output() selectedIcon = new EventEmitter<any>();

    icons: any = []
    iconsPathUrl = "assets/icons/icons.json"

    @ViewChild('pop', { static: true }) popover: any;

    onOutsideClick(event) {
        if (!this._eref.nativeElement.contains(event.target)) 
            this.popover.hide();
    }


    constructor(
        private service: SharedService,
        private _eref: ElementRef
    ) { }

    ngOnInit() {
        this.getIconsList();
    }

    ngOnChanges() {

    }


    getIconsList() {
        this.service.get(this.iconsPathUrl, {})
            .subscribe(response => {
                this.icons = response && response.icons ? response.icons : [];
            }, res => {

            })
    }

    iconSelected: string = ""
    selectIcon(icon) {
        this.selectedIcon.emit(icon);
    }


}